function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3333 12C24.3333 5.4 18.9333 0 12.3333 0C5.73325 0 0.333252 5.4 0.333252 12C0.333252 18.6 5.73325 24 12.3333 24C18.9333 24 24.3333 18.6 24.3333 12ZM6.93325 9.6L17.7333 9.6L12.3333 16.8L6.93325 9.6Z",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3333 12C24.3333 5.4 18.9333 0 12.3333 0C5.73325 0 0.333252 5.4 0.333252 12C0.333252 18.6 5.73325 24 12.3333 24C18.9333 24 24.3333 18.6 24.3333 12ZM6.93325 9.6L17.7333 9.6L12.3333 16.8L6.93325 9.6Z",
  fill: "white"
});

var _ref4 = React.createElement("g", {
  mask: "url(#mask0_3737_7625)"
}, React.createElement("rect", {
  x: 24.3333,
  width: 24,
  height: 24,
  transform: "rotate(90 24.3333 0)",
  fill: "#004152"
}));

var SvgDropdown = function SvgDropdown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("mask", {
    id: "mask0_3737_7625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _ref3), _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDropdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown.641c1a68.svg";
export { ForwardRef as ReactComponent };